import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconColorSwatch: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconColorSwatch"><Path d="M11.8302 19L18.47 7.49948M10.0006 20.8301L22.125 13.8301L18.47 7.49948M12.5 3.22091L18.8302 6.87564L18.47 7.49948M12.5 3.22091V2.5H2.5V16.5C2.5 19.2614 4.73858 21.5 7.5 21.5C10.2614 21.5 12.5 19.2614 12.5 16.5V3.22091ZM9.5 16.5C9.5 17.6046 8.60457 18.5 7.5 18.5C6.39543 18.5 5.5 17.6046 5.5 16.5C5.5 15.3954 6.39543 14.5 7.5 14.5C8.60457 14.5 9.5 15.3954 9.5 16.5Z" stroke="currentColor" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconColorSwatch;
